import { httpService } from "@/common/services/HttpService";
import { UAUserAccess } from "@/user-administration/models/UAUserAccess";
import { Access } from "@/common/models/Access";

class UAAccessService {
  async getAccess(storeId: string): Promise<UAUserAccess[]> {
    const { data } = await httpService.getInstance().get<UAUserAccess[]>("/api/v1/backoffice/admin/access", {
      params: { resourceId: storeId, resourceType: "STORE" },
    });
    return data;
  }

  async createAccess(access: Access): Promise<UAUserAccess[]> {
    const { data } = await httpService.getInstance().post<UAUserAccess[]>("/api/v1/backoffice/admin/access", access);
    return data;
  }

  async updateAccess(access: UAUserAccess): Promise<UAUserAccess[]> {
    const { data } = await httpService
      .getInstance()
      .patch<UAUserAccess[]>("/api/v1/backoffice/admin/access/" + access.id, access);
    return data;
  }

  async removeAccess(access: UAUserAccess): Promise<void> {
    return await httpService.getInstance().delete("/api/v1/backoffice/admin/access/" + access.id, {
      params: { resourceId: access.resourceId, resourceType: access.resourceType, userId: access.userId },
    });
  }
}

export const accessService = new UAAccessService();
